var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunMornig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9792 11.4583C9.73027 11.4583 7.90719 9.6477 7.90719 7.41421C7.90719 5.1807 9.73027 3.37009 11.9792 3.37009C14.228 3.37009 16.0511 5.1807 16.0511 7.41421C16.0511 9.6477 14.228 11.4583 11.9792 11.4583ZM11.9792 10.1103C13.4784 10.1103 14.6938 8.90318 14.6938 7.41421C14.6938 5.92521 13.4784 4.71813 11.9792 4.71813C10.4799 4.71813 9.26451 5.92521 9.26451 7.41421C9.26451 8.90318 10.4799 10.1103 11.9792 10.1103ZM11.3005 0H12.6578V2.02206H11.3005V0ZM6.22053 2.64817L7.1803 1.69497L8.61995 3.12478L7.66019 4.07798L6.22053 2.64817ZM16.778 1.69497L17.7378 2.64817L16.2982 4.07798L15.3383 3.12478L16.778 1.69497ZM19.4444 6.74019V8.08823H17.4084V6.74019H19.4444ZM6.54987 6.74019V8.08823H4.51389V6.74019H6.54987Z",
    fill: "#9E9C9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01004 11.3984L16.6169 18.6392L1.22119 18.443L9.01004 11.3984Z",
    fill: "#9E9C9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1113 11.3984L23.7181 18.6392L8.32245 18.443L16.1113 11.3984Z",
    fill: "#9E9C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunMornig);
export default __webpack_public_path__ + "static/media/sun-mornig.b90deccdbe66f8e8867a62c530f0e2a6.svg";
export { ForwardRef as ReactComponent };